// extracted by mini-css-extract-plugin
export default {"popup":"Popup--popup--OvtFX","contents":"Popup--contents--Ej052","arrow":"Popup--arrow--WvS8a"};